import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  Autocomplete,
  Box,
  Paper,
  Grid,
  Button,
  Typography,
  TextField,
  InputLabel,
  IconButton,
  FormControl,
} from "@mui/material";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaAddressCard } from "react-icons/fa";
import Cookies from "js-cookie";
import AxiosInstance from "../../apis/AxiosInstance";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  boxShadow: "none",
  color: theme.palette.text.secondary,
}));

export default function CollegeAppointmentFromCampusSpoc() {
  //props form the spoc-creation page
  const { state } = useLocation();

  // state values  for the autocomplete component
  const [selectedUniversity, setSelectedUniversity] = useState(
    state.data.university.id
  );
  const [selectedCollege, setSelectedCollege] = useState(state.data.college.id);
  const [selectedSpoc, setSelectedSpoc] = useState(state.data.id);
  const [expectedStudents, setExpectedStudents] = useState("");
  const [incubation_type, setincubation_type] = useState("");
  const [comment, setComment] = useState("");
  const [selectedColgState, setSelectedColgState] = useState(
    state.data.state.id
  );
  const [selectedColgDistrict, setselectedColgDistrict] = useState(
    state.data.district.id
  );
  const [unitNameOption, setUnitNameOption] = useState([]);
  const [unitNameData, setUnitNameData] = useState(null);
  const [searchUnitName, setSearchUnitName] = useState("");

  const [yop, setYop] = useState(null);
  const [yopOptions, setYopOptions] = useState([]);
  const currentYear = new Date().getFullYear();

  const navigate = useNavigate();

  // to expectedStudents
  let handleStudents = (e) => {
    const inputValue = e.target.value.replace(/[^0-9]/g, ""); // remove non-numeric characters
    if (inputValue.length <= 5) {
      setExpectedStudents(inputValue);
    }
  };

  // Error Handling for Create Addressing Faculty
  const [error, setError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [doc_type_Options, setDoc_type_Options] = useState([]);
  const [searchDocType, setSearchDocType] = useState("");

  const [fields, setFields] = useState([
    { id: Date.now(), docTypeData: null, selectedVideo: null, status: "" },
  ]);

  const handleAddFields = () => {
    setFields([
      ...fields,
      { id: Date.now(), docTypeData: null, selectedVideo: null, status: "" },
    ]);
  };

  const handleRemoveFields = (id) => {
    setFields(fields.filter((field) => field.id !== id));
  };

  // const handleInputChange = (id, event) => {
  //   const values = fields.map((field) => {
  //     if (field.id === id && event.target.name === "selectedVideo") {
  //       return { ...field, selectedVideo: event.target.files[0] };
  //     }
  //     return field;
  //   });
  //   setFields(values);
  // };

  const handleInputChange = (id, event) => {
    const { name, value, files } = event.target;
    const values = fields.map((field) => {
      if (field.id === id) {
        if (name === "selectedVideo") {
          return { ...field, selectedVideo: files[0] };
        } else if (name === "status") {
          return { ...field, status: value };
        }
      }
      return field;
    });
    setFields(values);
  };

  const handleAutocompleteChange = (id, event, newValue) => {
    const values = fields.map((field) => {
      if (field.id === id) {
        return { ...field, docTypeData: newValue };
      }
      return field;
    });
    setFields(values);
  };

  useEffect(() => {
    const generateYears = () => {
      const startYear = currentYear - 1;
      const endYear = currentYear + 5;
      const years = [];

      for (let year = startYear; year <= endYear; year++) {
        years.push(year.toString());
      }

      setYopOptions(years);
    };
    generateYears();
  }, [currentYear]);

  //==================================FUNCTION TO HANDLE FORM SUBMITION=============================
  let handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    let formData = new FormData();

    // Tokens and config
    const parseLog = (a) => {
      const userData = a ? JSON.parse(a) : { token: "" };
      const { token } = userData;
      return token;
    };
    const token = parseLog(Cookies.get("logged"));

    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `${token}`,
      },
    };

    try {
      // if (expectedStudents.toString().startsWith("0")) {
      //   toast.error("Please enter a valid number for Students Targeted");
      //   setIsSubmitting(false);
      //   return; // Stop further execution
      // }
      setError(false);
      const formattedCollegeSpoc = {
        [state.data.id]: {
          name: state.data.name,
        },
      };
      formData.append(
        "state",
        JSON.stringify({
          id: state.data.state.id,
          name: state.data.state.name,
        })
      );
      formData.append(
        "district",
        JSON.stringify({
          id: state.data.district.id,
          name: state.data.district.name,
        })
      );
      formData.append(
        "college",
        JSON.stringify({
          id: state.data.college.id,
          name: state.data.college.name,
        })
      );
      formData.append(
        "university",
        JSON.stringify({
          id: state.data.university.id,
          name: state.data.university.name,
        })
      );
      formData.append("expected_students", Number.parseInt(expectedStudents));
      formData.append("college_spoc", JSON.stringify(formattedCollegeSpoc));
      formData.append("yop", yop);
      formData.append("comment", comment);
      formData.append(
        "unit",
        JSON.stringify({
          id: unitNameData.ID,
          name: unitNameData.name,
        })
      );
      fields.forEach((field, index) => {
        if (field.selectedVideo) {
          formData.append("file", field.selectedVideo);
        }
        if (field.docTypeData) {
          formData.append("doc_type", JSON.stringify(field.docTypeData.ID));
        }
        formData.append("status", field.status ? field.status : "");
      });

      await AxiosInstance.post("/cc_appointment", formData, config)
        .then((response) => {
          toast.success("Successfully college appointment data is submitted");
          if (response.status == 200) {
            setTimeout(() => {
              navigate("/");
            }, 1800);
          }
        })
        .catch((error) => {
          toast.error(error.response.data.error);
          setIsSubmitting(false);
        });
    } catch (error) {
      // console.log(error.code);
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    let fetchData = async () => {
      //Qualification Api
      if (searchUnitName !== "") {
        let data = await AxiosInstance.get(
          `/unit?search_keyword=${searchUnitName}&limit=10`
        );
        let finalData = data.data.data;

        setUnitNameOption(finalData);
      } else {
        let data = await AxiosInstance.get(`/unit?limit=10`);
        let finalData = data.data.data;

        setUnitNameOption(finalData);
      }
    };
    fetchData();
  }, [searchUnitName]);

  useEffect(() => {
    let fetchData = async () => {
      //DocType Api
      if (searchDocType !== "") {
        let data = await AxiosInstance.get(
          `/doc_type?search_keyword=${searchDocType}&limit=10`
        );
        let finalData = data.data.data;

        setDoc_type_Options(finalData);
      } else {
        let data = await AxiosInstance.get(`/doc_type?limit=10`);
        let finalData = data.data.data;

        setDoc_type_Options(finalData);
      }
    };
    fetchData();
  }, [searchDocType]);

  // Reset Data
  let resetData = (e) => {
    e.preventDefault();

    setSelectedColgState(null);
    setselectedColgDistrict(null);
    setSelectedUniversity(null);
    setSelectedCollege(null);
    setSelectedSpoc(null);
    setExpectedStudents("");
    setComment("");
  };

  return (
    <section style={{ width: "100%", height: "auto" }}>
      <article
        style={{
          width: "98%",
          height: "auto",
          margin: "0 auto",
          marginTop: "4.3%",
          background: "#efefef",
        }}
      >
        <Box>
          <Paper variant="outlined">
            <Box
              sx={{
                width: "100%",
                background: "#DDE6ED",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "2px solid #9BA4B5",
               
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  color: "#081f37",
                  fontSize: {
                    xs: "20px", // Smaller font size on small screens
                    sm: "25px", // Medium font size on small to medium screens
                    md: "30px", // Larger font size on medium to large screens
                  },
                  textTransform: "capitalize",
                  fontWeight: "600",
                  letterSpacing: "1.02px",
                  justifyContent: "center",
                  margin:"0 auto"
                }}
              >
                COLLEGE APPOINTMENT FORM
              </Box>
            </Box>
            <form
              style={{
                flexGrow: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                padding: "1%",
              }}
              onSubmit={handleSubmit}
            >
              <Grid container spacing={1}>
                {/* colleg state */}
                <Grid md={3} xs={12}>
                  <Item>
                    <InputLabel
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "14px",
                        fontWeight: "bolder",
                        color: "#495579",
                      }}
                    >
                      College State
                    </InputLabel>
                    <TextField
                      fullWidth
                      disabled
                      // label="State"
                      variant="outlined"
                      onChange={() => {
                        setSelectedColgState(state.data.state.id);
                      }}
                      required
                      value={state.data.state.name}
                      name="state_name"
                    />
                  </Item>
                </Grid>

                {/* colleg district */}
                <Grid md={3} xs={12}>
                  <Item>
                    <InputLabel
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "14px",
                        fontWeight: "bolder",
                        color: "#495579",
                      }}
                    >
                      College District
                    </InputLabel>
                    <TextField
                      fullWidth
                      disabled
                      onChange={() => {
                        setselectedColgDistrict(state.data.district.id);
                      }}
                      variant="outlined"
                      required
                      value={state.data.district.name}
                    />
                  </Item>
                </Grid>

                {/* university  */}
                <Grid md={3} xs={12}>
                  <Item>
                    <InputLabel
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "14px",
                        fontWeight: "bolder",
                        color: "#495579",
                      }}
                    >
                      University
                    </InputLabel>
                    <TextField
                      fullWidth
                      variant="outlined"
                      required
                      disabled
                      value={state.data.university.name}
                      name="university_name"
                      onChange={(event) => {
                        setSelectedUniversity(state.data.university.id);
                      }}
                    />
                  </Item>
                </Grid>

                {/* College   */}
                <Grid md={3} xs={12}>
                  <Item>
                    <InputLabel
                      htmlFor="my-input"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "14px",
                        fontWeight: "bolder",
                        color: "#495579",
                      }}
                    >
                      College
                    </InputLabel>
                    <TextField
                      fullWidth
                      disabled
                      variant="outlined"
                      required
                      value={state.data.college.name}
                      onChange={() => {
                        setSelectedCollege(state.data.college.id);
                      }}
                    />
                  </Item>
                </Grid>

                {/* SPOC  */}
                <Grid md={3} xs={12}>
                  <Item>
                    <InputLabel
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "14px",
                        fontWeight: "bolder",
                        color: "#495579",
                      }}
                    >
                      Spoc Name
                    </InputLabel>
                    <TextField
                      fullWidth
                      variant="outlined"
                      disabled
                      onChange={() => {
                        setSelectedSpoc(state.data.id);
                      }}
                      value={state.data.name}
                    />
                  </Item>
                </Grid>

                <Grid md={3} xs={12} style={{ marginTop: "1.1%" }}>
                  <Item
                    onChange={(e) => {
                      setSearchUnitName(e.target.value);
                    }}
                  >
                    <Autocomplete
                      options={unitNameOption}
                      value={unitNameData}
                      name="unitNameOption"
                      onChange={(event, newData_xy) => {
                        setUnitNameData(newData_xy);
                      }}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Unit Name"
                          variant="outlined"
                          required
                        />
                      )}
                    />
                  </Item>
                </Grid>
                <Grid md={3} xs={12} style={{ marginTop: "1.1%" }}>
                  <Item>
                    <TextField
                      required
                      fullWidth
                      id="expected_students"
                      label="Students Targeted"
                      name="expected_students"
                      value={expectedStudents}
                      onChange={handleStudents}
                      inputProps={{ maxLength: 5 }}
                      variant="outlined"
                      type="text"
                      error={error && !expectedStudents}
                      helperText={
                        error && !expectedStudents
                          ? "Please Select Expected Students"
                          : null
                      }
                    />
                  </Item>
                </Grid>
                <Grid md={3} xs={12} style={{ marginTop: "1.1%" }}>
                  <Item>
                    <FormControl fullWidth sx={{ margin: 0 }}>
                      <Autocomplete
                        required
                        options={yopOptions}
                        value={yop}
                        name="year_of_passout"
                        onChange={(e, newyop) => {
                          setYop(newyop);
                        }}
                        getOptionLabel={(option) => option}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select YOP"
                            variant="outlined"
                            required
                            error={error && !yop}
                            helperText={
                              error && !yop ? "Please select YOP" : null
                            }
                          />
                        )}
                      />
                    </FormControl>
                  </Item>
                </Grid>

                <Grid
                  container
                  spacing={1}
                  item
                  xs={12}
                  style={{ marginTop: "0.3%", marginLeft: "3%" }}
                >
                  {fields.map((field, index) => (
                    <React.Fragment key={field.id}>
                      <Paper
                        elevation={3}
                        style={{
                          padding: "16px",
                          marginBottom: "16px",
                          width: "95%",
                          border: "1px solid #ddd",
                        }}
                      >
                        <Grid container spacing={1}>
                          <Grid
                            item
                            md={3}
                            xs={12}
                            style={{ marginLeft: "8px" }}
                            onChange={(e) => setSearchDocType(e.target.value)}
                          >
                            <Autocomplete
                              options={doc_type_Options}
                              value={field.docTypeData}
                              name="doc_type_Options"
                              onChange={(event, newValue) =>
                                handleAutocompleteChange(
                                  field.id,
                                  event,
                                  newValue
                                )
                              }
                              getOptionLabel={(option) => option.name}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Select Doc Type"
                                  variant="outlined"
                                  // required
                                />
                              )}
                            />
                          </Grid>
                          {/* <Grid item md={4} style={{ marginLeft: "17px" }}>
                            <TextField
                              type="file"
                              style={{ width: "450px" }}
                              name="selectedVideo"
                              // required={Boolean(field.docTypeData)}
                              onChange={(e) => handleInputChange(field.id, e)}
                              inputProps={{
                                accept: ".pdf,.doc,.docx,.png,.jpeg,.jpg,.csv",
                              }}
                            />
                          </Grid> */}
                          <Grid
                            item
                            md={5}
                            xs={12}
                            style={{ marginLeft: "17px" }}
                          >
                            <TextField
                              type="file"
                              fullWidth
                              // style={{ width: "450px" }}
                              name="selectedVideo"
                              // required={Boolean(field.docTypeData)}
                              onChange={(e) => handleInputChange(field.id, e)}
                              inputProps={{
                                accept: "*/*",
                              }}
                            />
                          </Grid>
                          <Grid
                            item
                            md={3}
                            xs={12}
                            style={{ marginLeft: "17px" }}
                          >
                            <TextField
                              fullWidth
                              id="status"
                              label="Status"
                              name="status"
                              value={field.status}
                              onChange={(e) => handleInputChange(field.id, e)}
                              variant="outlined"
                              type="text"
                            />
                          </Grid>
                        </Grid>
                      </Paper>
                      <Grid
                        container
                        justifyContent="flex-end"
                        spacing={1}
                        style={{ width: "96%", marginTop: "-2%" }}
                      >
                        {index === fields.length - 1 && (
                          <Grid item>
                            <IconButton
                              onClick={handleAddFields}
                              sx={{ color: "green" }}
                            >
                              <AddIcon />
                            </IconButton>
                          </Grid>
                        )}
                        {fields.length > 1 && (
                          <Grid item>
                            <IconButton
                              onClick={() => handleRemoveFields(field.id)}
                              sx={{ color: "red" }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Grid>
                        )}
                      </Grid>
                    </React.Fragment>
                  ))}
                </Grid>

                <Grid item xs={12} md={12}>
                  <Item sx={{ display: "flex" }}>
                    <TextField
                      fullWidth
                      multiline
                      rows={2}
                      id="comment"
                      label="Comment"
                      name="comment"
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                    />
                  </Item>
                </Grid>
                <Grid
                  xs={12}
                  item
                  md={12}
                  // spacing={2}
                  // sx={{ mt: 5, mb: 2 }}
                  style={{
                    textAlign: "right",
                    padding: "5px",
                  }}
                >
                  <Button
                    onClick={resetData}
                    type="button"
                    variant="contained"
                    style={{
                      width: "10%",
                      marginRight: "3%",
                      backgroundColor: "#DF2E38",
                      color: "#e74646",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    type="submit"
                    variant="contained"
                    style={{
                      width: "10%",
                      color: "#F5F5F5",
                      backgroundColor: "#1976d2",
                      fontWeight: "bold",
                    }}
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Box>
      </article>
    </section>
  );
}
